import { FC, memo, useState, useEffect, useRef } from 'react';
import { Select, Space } from 'antd';
import { ConfigProvider } from 'antd';
import { useQuoteCardMobile } from '@/hooks/use-quote-card-mobile';
import Icon from '@ant-design/icons';
import styles from './SelectBlock.module.scss';
import { SelectBlockProps } from './SelectBlock.types';
import SelectIcon from '@/public/icon/select-icon.svg';
import TickIcon from '@/public/icon/tick-icon.svg';
import classNames from 'classnames';

const SelectBlock = memo((props: SelectBlockProps) => {
  const { optionData, value, onChange } = props;
  const selectRef = useRef(null);
  const isMobile = useQuoteCardMobile();

  return (
    <span className={styles.fwd_select_block}>
      <ConfigProvider
        theme={{
          components: {
            Select: {
              optionActiveBg: '#e87722',
              optionHeight: 36,
              optionLineHeight: '24px',
              optionSelectedBg: '#fff',
              optionFontSize: 16,
              optionSelectedFontWeight: 450
            }
          }
        }}
      >
        <Select
          id="age_input"
          ref={selectRef}
          popupClassName="drop"
          value={value}
          onChange={onChange}
          onBlur={() => (selectRef.current as any).blur()}
          options={optionData}
          suffixIcon={
            <Icon component={SelectIcon} style={{ fontSize: 20, pointerEvents: 'none' }} />
          }
          onPopupScroll={(e: any) => {
            e.stopPropagation();
          }}
          optionRender={option => (
            <span
              className={classNames(styles.fwd_select_option, 'age_select')}
              style={{ width: '100%', display: 'inline-flex', justifyContent: 'space-between' }}
            >
              <span>{option.data.label} </span>
              <Icon
                component={TickIcon}
                style={{
                  fontSize: 20,
                  pointerEvents: 'none',
                  color: '#e87722',
                  display: value === option.data.value ? 'inline' : 'none'
                }}
              />
            </span>
          )}
        ></Select>
      </ConfigProvider>
    </span>
  );
});
export default SelectBlock;
